import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import sty from './ProdDetailPage.module.css';

import { closeBtn } from '../../assets/images/product/prodImages';

const PrdDtlSpec = ({ specSeq, specName, specDscr, specType, totalSpecs, index }) => {

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef(null);

    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };

    const closePopover = () => {
        setIsPopoverOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                closePopover();
            }
        };

        if (isPopoverOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isPopoverOpen]);

    const handleSpecNameClick = () => {
        if (['A', 'B', 'C'].includes(specType)) {
            togglePopover();
        }
    };

    return (
        <>
            <td className={sty.specName} onClick={handleSpecNameClick}>
                {['A', 'B', 'C'].includes(specType) ? (
                    <span className={sty.popTd}>{specName}</span>
                ) : (
                    specName
                )}
            </td>
            {/* <td className={sty.specName} onClick={handleSpecNameClick}>{specName}</td> */}
            {index === totalSpecs - 1 ? (
                <td className={sty.specDscr} colSpan="3">{specDscr}</td>
            ) : (
                <td className={sty.specDscr}>{specDscr}</td>
            )}
            {isPopoverOpen &&
                ReactDOM.createPortal(
                    <div className={sty.popover}  ref={popoverRef}>
                        <div className={sty.closeBtnDiv}><button onClick={togglePopover} className={sty.closeBtn}><img src={closeBtn} alt='X'/></button></div>
                        {specType === 'A' && 
                            <div className={sty.popDiv}>
                                <tbody className={sty.popBody}>
                                    <tr>
                                        <td className='fw-500'>125KHz</td>
                                        <td className='w-30'>저주파</td>
                                        <td>단거리통신, 부착환경 제약 덜 받음, 낮은 메모리 용량</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500'>13.56MHz</td>
                                        <td>고주파</td>
                                        <td>단거리통신, 보안성 우수, 높은 메모리 용량</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500'>900MHz</td>
                                        <td>저주파</td>
                                        <td>장거리통신, 다중인식 가능, 경제적인 가격</td>
                                    </tr>
                                </tbody>
                            </div>
                        }
                        {specType === 'B' && 
                            <div className={sty.popDiv}>
                                <tbody className={sty.popBody}>
                                    <tr>
                                        <td className='fw-500'>125KHz</td>
                                        <td className='w-100'>ISO 11784/11785</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500' rowSpan={2}>13.56MHz</td>
                                        <td>ISO 14443 A/B</td>
                                    </tr>
                                    <tr>
                                        <td>ISO 15693</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500' rowSpan={2}>900MHz</td>
                                        <td>ISO 18000-6B</td>
                                    </tr>
                                    <tr>
                                        <td>ISO 18000-6C</td>
                                    </tr>
                                </tbody>
                            </div>
                        }
                        {specType === 'C' &&
                            <div className={sty.popDiv}>
                                <tbody className={sty.popBody}>
                                    <tr>
                                        <td className='fw-500'>USB</td>
                                        <td className='w-30'>USB A / C</td>
                                        <td>통신거리 최대 2M, 안정성 우수, 빠른 데이터 송수신</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500'>RS232</td>
                                        <td rowSpan={2}>시리얼선</td>
                                        <td>통신거리 최대 15M, 직렬포트, 백그라운드 통신가능</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500'>RS485</td>
                                        <td>통신거리 최대 1.5KM, 병렬포트, 백그라운드 통신가능</td>
                                    </tr>
                                    <tr>
                                        <td className='fw-500'>TCP/IP</td>
                                        <td>LAN선</td>
                                        <td>통신거리 제약 없음, 주소체계 중앙제어 가능</td>
                                    </tr>
                                </tbody>
                            </div>
                        }
                    </div>,
                    document.querySelector('tr')
                )
            }
        </>
    );
};



export default PrdDtlSpec;